import React from 'react'
import { Form, Radio as RadioAnt } from 'antd'
import { UIDirection, Indent, RadioOptionType, RadioProps as RadioComponentProps } from 'LibNeo'
import { Callback } from 'Src/types/utilTypes'
import { WrappedFormUtils } from 'antd/lib/form/Form'
import {
	RadioGroup,
	CardBody,
	CardBodyTitleWrapper,
	CardBodyDescription,
	CardBodyTitle,
	RadioCardIcon,
	CardBodyOptionText,
	LinkWrapper,
} from './styled'

type Primitive = string | number | boolean

type FormAndChangeEventProps<T> = {
	name?: string
	form?: WrappedFormUtils
	onChange?: (v: T) => void
}

export type CardRadioOptionType<T> = {
	optionText?: string | JSX.Element
	optionIcon?: string
	description?: string
	iconTooltip?: string
	customIcon?: JSX.Element
	actionTitle?: string
	actionClick?: Callback
} & RadioOptionType<T>

type CardRadioComponentProps<T> = {
	options?: CardRadioOptionType<T>[]
} & RadioComponentProps<T> &
	FormAndChangeEventProps<T>

export const RadioCardComponent = <T extends Primitive>({
	disabled = false, // гарантирует появление атрибута data-qa-disabled, ввиду типа boolean | undef
	form,
	name,
	onChange,
	fieldOptions,
	options = [],
	direction = UIDirection.VERTICAL,
	value,
}: CardRadioComponentProps<T>) => {
	const isHorizontal = direction === UIDirection.HORIZONTAL

	const getOption = (item: CardRadioOptionType<T>) => (
		<>
			{item?.optionText && <CardBodyTitle>{item.optionText}</CardBodyTitle>}
			{item?.optionIcon && (
				<RadioCardIcon
					name={item.optionIcon}
					disabled={item?.disabled}
					tooltip={item?.iconTooltip}
				/>
			)}
			{item.customIcon && <>{item.customIcon}</>}
		</>
	)

	const getRadio = () => {
		const switcher = options.map((item) => (
			<RadioAnt.Button key={item.key} value={item.value} disabled={item.disabled}>
				<CardBody>
					<Indent bottom={12}>
						<CardBodyTitleWrapper>
							<CardBodyTitle>{item.label}</CardBodyTitle>
							<CardBodyOptionText>{getOption(item)}</CardBodyOptionText>
						</CardBodyTitleWrapper>
					</Indent>
					<CardBodyDescription>{item?.description}</CardBodyDescription>
					{Boolean(item.actionTitle) && (
						<Indent top={12}>
							<LinkWrapper title={item.actionTitle} onClick={item.actionClick} />
						</Indent>
					)}
				</CardBody>
			</RadioAnt.Button>
		))

		return form ? (
			<Form.Item data-qa-disabled={disabled}>
				{form.getFieldDecorator(name, { ...fieldOptions })(
					<RadioGroup
						disabled={disabled}
						isHorizontal={isHorizontal}
						onChange={(e) => onChange?.(e.target.value)}
					>
						{switcher}
					</RadioGroup>
				)}
			</Form.Item>
		) : (
			<RadioGroup
				onChange={(e) => onChange(e.target.value)}
				value={value}
				disabled={disabled}
				isHorizontal={isHorizontal}
			>
				{switcher}
			</RadioGroup>
		)
	}

	return getRadio()
}
